import type { AuthSessionStore, PendingAction } from '../../types/ports';

/**
 * Encapsulates the pending-action bookkeeping that was formerly
 * inlined in AuthSession. Pending actions are cross-redirect state
 * (errors, "needs phone") stored in the session store.
 */
export class PendingActionManager {
  constructor(private readonly getSessionStore: () => AuthSessionStore | undefined) {}

  consume(): PendingAction | null {
    const action = this.peek();
    if (action) this.clear();
    return action;
  }

  peek(): PendingAction | null {
    const store = this.getSessionStore();
    const pendingError = store?.getPendingError();
    if (pendingError) {
      return { type: 'error', message: pendingError.message, code: pendingError.code };
    }
    if (store?.getNeedsPhone()) return { type: 'collect_phone' };
    return null;
  }

  clear(): void {
    const store = this.getSessionStore();
    store?.dispatch({ type: 'CLEAR_PENDING_ERROR' });
    store?.dispatch({ type: 'CLEAR_NEEDS_PHONE' });
  }
}
